import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                极速影视
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              极速不缓冲，高清在线观看。致力于为用户提供最流畅、最高清的免费在线影视观看体验。秒开即播，追剧神器。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              影视分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@chentaotao.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 极速影视 JisuMovies. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}